import { Input, SIZE } from 'baseui/input'
import { Search } from 'baseui/icon'
import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'
import { Card } from '@/shared/theme/styled-components'
import MessageGridSection from '../MessageGridSection/MessageGridSection'
import useHomeMessages from '../useHomeMessages'
import { SearchWrapper, Toolbar, searchInputOverrides } from './styled-components'

const HomeMessagesBoard = () => {
  const { t, error, nothingToShow, search, welcome, scripts, labels, onSearch, onToggle } = useHomeMessages()

  if (nothingToShow) return null

  return (
    <Card id='home-messages'>
      <Toolbar>
        <SearchWrapper>
          <Input
            id='home-messages-search'
            size={SIZE.compact}
            value={search}
            onChange={onSearch}
            placeholder={t('home:messages.search_placeholder')}
            startEnhancer={<Search size={20} />}
            clearable
            clearOnEscape
            overrides={searchInputOverrides}
          />
        </SearchWrapper>
      </Toolbar>

      <SDNotification type='negative' hidden={!error} primaryText={error ?? ''} />

      <MessageGridSection
        section='welcome'
        title={t('home:messages.welcome_title')}
        noResultsText={t('home:messages.no_results')}
        view={welcome}
        labels={labels}
        onToggle={onToggle}
      />
      <MessageGridSection
        section='scripts'
        title={t('home:messages.scripts_title')}
        noResultsText={t('home:messages.no_results')}
        view={scripts}
        labels={labels}
        onToggle={onToggle}
      />
    </Card>
  )
}

export default HomeMessagesBoard
